import { render, staticRenderFns } from "./addTeachLock.vue?vue&type=template&id=8a1d9810&"
import script from "./addTeachLock.vue?vue&type=script&lang=js&"
export * from "./addTeachLock.vue?vue&type=script&lang=js&"
import style0 from "./addTeachLock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports